//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable arrow-body-style */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-param-reassign */
import { ref, computed, watch } from '@vue/composition-api'
import { mdiPlus, mdiDeleteOutline, mdiClose, mdiMenuDown } from '@mdi/js'
import { required, integerValidator, between } from '@core/utils/validation'
import { useUtils } from '@core/libs/i18n'

export default {
  name: 'ChangeQuantity',
  model: {
    prop: 'isModalOpen',
    event: 'update:is-modal-open',
  },
  props: {
    isModalOpen: {
      type: Boolean,
      required: true,
    },
    minPlayers: {
      type: Number,
      default: 12,
      required: false,
    },
    quantity: {
      type: Number,
      default: 12,
      required: false,
    },
  },
  setup(props, { emit }) {
    const { t } = useUtils()
    const form = ref(null)
    const quantityPlayer = ref(null)

    const computedIsModalOpen = computed(() => props.isModalOpen)
    const computedMinPlayers = computed(() => props.minPlayers)

    const validateMinPlayer = v => {
      if (v >= computedMinPlayers.value) return true

      return `Número de jugadores debe ser mayor o igual a ${computedMinPlayers.value}`
    }

    const onSave = () => {
      if (form.value.validate()) emit('change-quantity', quantityPlayer.value)
    }

    watch([computedIsModalOpen], () => {
      if (computedIsModalOpen.value) quantityPlayer.value = props.quantity
    })

    return {
      // data
      form,
      quantityPlayer,

      // computed
      computedMinPlayers,
      computedIsModalOpen,

      // methods
      onSave,

      // validations
      required,
      integerValidator,
      validateMinPlayer,
      between,

      // i18n
      t,

      // icons
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiClose,
        mdiMenuDown,
      },
    }
  },
}
